import React from "react";
import { Card } from "antd";
import { UI_COLORS } from "../../config";
import SignInButton from "../commons/SignInButton/SignInButton";
import { useTranslation } from "../../i18n";

// ...existing code...
// Styles
const CARD_STYLE = { width: 480 };
const CARD_BODY_STYLE = { padding: "2rem" };
const HEADING_STYLE = { color: UI_COLORS.primary };

/**
 * Card content sections
 */
const CardLogo = React.memo(() => (
  <div className="flex justify-center mb-4">
    <img src="/logo-RINA-DPP.png" alt="RINA Logo DPP" className="h-32" />
  </div>
));

// receive `t` as prop
const CardHeading = React.memo(({ t }) => (
  <h2 className="text-xl font-bold mb-4" style={HEADING_STYLE}>
    {t("login.title")}
  </h2>
));

// receive `t` as prop
const CardDescription = React.memo(({ t }) => (
  <p className="mb-6 text-base">{t("login.description")}</p>
));


/**
 * Login card component displayed when user is not authenticated
 */
const LoginCard = React.memo(() => {
  const { t } = useTranslation(); // use the hook once here

  return (
    <div className="w-full flex justify-center items-center">
      <Card
        className="rounded-2xl shadow-lg text-center"
        style={CARD_STYLE}
        styles={{ body: CARD_BODY_STYLE }}
      >
        <CardLogo />
        <CardHeading t={t} />
        <CardDescription t={t} />
        <SignInButton>{t("login.button_sign_in")}</SignInButton>
      </Card>
    </div>
  );
});

export default LoginCard;